import React from 'react';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { Row, Col, Clearfix, Button } from 'react-bootstrap';
import Masonry from 'react-masonry-component';

import { fileUploadHelper } from 'actions/UploadActions';
import { removePluginImage } from 'actions/DataActions';

import EntityPropsUpdater from 'component/EntityPropsUpdater';

import WhiteLabelPluginImage from 'components/layout/whiteLabel/WhiteLabelPluginImage';
import WhiteLabelPluginUploadImage from 'components/layout/whiteLabel/WhiteLabelPluginUploadImage';

class WhiteLabelPluginImages extends EntityPropsUpdater {
  constructor(props) {
    super(props);

    this.defaultFieldTree = ['assets'];
  }

  setDefault = index => {
    const { entity, changeEntity } = this.props;
    const img = entity.getAssets().getImgs()[index];

    const value = entity.createValue('defaultImg', [], img);
    const newEntity = { ...entity.updateValue('defaultImg', value) };

    changeEntity(newEntity);
  };

  delete = index => {
    const { entity, removePluginImage } = this.props;
    removePluginImage(entity.data.id, index);
  };

  manualUpload = files => {
    for (let i = 0; i < files.length; i++) {
      const file = files.item(i);
      this.props.uploadFile(file, this.props.upload.context.uploadLink, this.props.upload.context.data);
    }
  };

  render() {
    const {
      intl: { messages },
      entity,
      entityLoaded,
    } = this.props;

    const fileUploadButton = (
      <span>
        <input
          type="file"
          ref={ref => (this.uploadInput = ref)}
          style={{ display: 'none' }}
          onChange={e => this.manualUpload(e.target.files)}
        />
        <Button bsSize="sm" class="btn-rounded" bsStyle="primary" onClick={e => this.uploadInput.click()}>
          <i class="fa fa-upload m-r-10" /> {messages.upload}
        </Button>
      </span>
    );

    return (
      <div class="clearfix">
        <Row>
          <Col xs={12}>
            <div class="panel panel-transparent">
              <div class="panel-body">
                <p>{messages.images}</p>

                {entityLoaded && entity.getAssets().getImgs().length ? (
                  <div>
                    <div class="padding-20 m-b-15 bg-master-lighter text-right">{fileUploadButton}</div>

                    <Masonry
                      className="gallery"
                      elementType="div"
                      options={{ transitionDuration: 0 }}
                      disableImagesLoaded={false}
                      updateOnEachImageLoad
                    >
                      {/* show all images */}
                      {entity
                        .getAssets()
                        .getImgs()
                        .map((image, i) => {
                          return (
                            <WhiteLabelPluginImage
                              image={image}
                              entity={entity}
                              setDefault={() => this.setDefault(i)}
                              delete={() => this.delete(i)}
                              key={i}
                            />
                          );
                        })}

                      {/* show images that are being uploaded */}
                      {this.props.upload.isUploading
                        ? this.props.upload.files.map((uploadFile, i) => {
                            if (uploadFile.isUploading && uploadFile.context === 'plugin_img') {
                              return <WhiteLabelPluginUploadImage upload={uploadFile} key={i} />;
                            }
                          })
                        : null}
                      <Clearfix />
                    </Masonry>
                  </div>
                ) : null}

                {entityLoaded && !entity.getAssets().getImgs().length ? (
                  <div class="padding-20 bg-master-lighter">
                    <Clearfix>
                      <div class="pull-left">{messages.no_images_yet}</div>
                      <div class="pull-right">{fileUploadButton}</div>
                    </Clearfix>
                  </div>
                ) : null}
              </div>
            </div>
          </Col>
        </Row>
      </div>
    );
  }
}
WhiteLabelPluginImage.defaultProps = {
  inModal: false,
};

const mapStateToProps = state => {
  return {
    upload: state.upload,
  };
};
const mapDispatchToProps = dispatch => {
  return {
    uploadFile: fileUploadHelper(dispatch),
    removePluginImage: (pluginId, variantId, imageIndex) => {
      dispatch(removePluginImage(pluginId, variantId, imageIndex));
    },
  };
};

export default injectIntl(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(WhiteLabelPluginImages)
);
